import { carouselItems } from '@/mocks/home';

const carouselImages = [
  'https://readdy.ai/api/search-image?query=Epic%20Chinese%20animation%20style%20scene%20with%20a%20warrior%20standing%20on%20a%20mountain%20peak%20overlooking%20ancient%20floating%20temples%2C%20dramatic%20golden%20sunset%20lighting%2C%20warm%20crimson%20and%20gold%20colors%2C%20grand%20cinematic%20composition%2C%20Chinese%20fantasy%20aesthetic%2C%20epic%20scale%2C%20professional%20digital%20art&width=1000&height=560&seq=carousel-manga-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Nostalgic%20Japanese%20anime%20style%20collage%20featuring%20classic%20shonen%20manga%20elements%2C%20warm%20vintage%20tones%2C%20adventure%20themed%20composition%2C%20nostalgic%20yet%20vibrant%20colors%2C%20heroic%20atmosphere%2C%20cinematic%20presentation%2C%20professional%20artwork%2C%20high%20quality&width=1000&height=560&seq=carousel-manga-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Modern%20Korean%20webtoon%20style%20art%20with%20sleek%20character%20designs%20and%20vibrant%20color%20palette%2C%20dynamic%20vertical%20composition%2C%20neon%20accents%20against%20dark%20background%2C%20stylish%20urban%20fantasy%20aesthetic%2C%20professional%20quality%2C%20trendy%20visual%2C%20high%20quality%20illustration&width=1000&height=560&seq=carousel-manga-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Cozy%20manga%20reading%20nook%20with%20a%20tablet%20displaying%20comic%20pages%2C%20warm%20ambient%20lighting%2C%20surrounded%20by%20manga%20volumes%2C%20minimalist%20modern%20interior%2C%20comfortable%20vibe%2C%20warm%20coral%20and%20cream%20tones%2C%20editorial%20photography%2C%20high%20quality&width=1000&height=560&seq=carousel-manga-04&orientation=landscape',
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 bg-primary-100/70 text-primary-700 text-xs font-medium px-3 py-1 rounded-full mb-4">
            <i className="ri-article-line text-xs"></i>
            <span>深度专题</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            深度解析漫画世界的热点话题与趋势洞察
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item, i) => (
            <div
              key={item.title}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 md:h-60 overflow-hidden">
                <img
                  src={carouselImages[i]}
                  alt={`古古漫画网 - ${item.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 text-xs font-medium rounded bg-accent-500/90 text-background-50 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-foreground-500 text-sm leading-relaxed line-clamp-3">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}